import { render, staticRenderFns } from "./CostCenters.vue?vue&type=template&id=edfcb132&scoped=true"
import script from "./CostCenters.vue?vue&type=script&lang=js"
export * from "./CostCenters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edfcb132",
  null
  
)

export default component.exports